/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospects_CreateProspectRequest = {
    availability_checked?: boolean;
    /**
     * AvailabilityCheckedAt is date-only. The service defaults it to today in the
     * organisation's timezone when availability_checked is true and none was sent.
     */
    availability_checked_at?: string;
    child_date_of_birth?: string;
    child_dob_is_estimated?: boolean;
    child_first_name?: string;
    child_last_name?: string;
    child_notes?: string;
    /**
     * DesiredCareDaysPerWeek is independent of DesiredCareWeekdays; a phone lead
     * often supplies only one of the two.
     */
    desired_care_days_per_week?: number;
    desired_care_weekdays?: Array<number>;
    desired_childcare_ids: Array<string>;
    desired_start_date?: string;
    first_contact_channel?: prospects_CreateProspectRequest.first_contact_channel;
    /**
     * OwnerEmployeeID is TRI-STATE, following the group-lead precedent (#1217,
     * groups.LeadEmployeeID):
     * key ABSENT              -> the server applies the DEFAULT owner rule (the
     * creating admin's own eligible employee row)
     * key present, null or "" -> explicitly UNASSIGNED; the default is skipped
     * key present with an id  -> that employee, validated for eligibility (422)
     *
     * It is a presence-tracking wrapper rather than a bare *string because Go's
     * encoding/json collapses an absent key and an explicit null onto the same
     * nil, and here those two mean OPPOSITE things. swaggertype:"string" plus
     * x-nullable keeps the generated schema and the TypeScript client a nullable
     * string, so no client ever sees the wrapper.
     */
    owner_employee_id?: string | null;
    parent1_city?: string;
    parent1_email?: string;
    parent1_first_name: string;
    parent1_house_number?: string;
    parent1_last_name: string;
    parent1_phone?: string;
    parent1_street?: string;
    parent1_zip?: string;
    parent2_email?: string;
    parent2_first_name?: string;
    parent2_last_name?: string;
    parent2_phone?: string;
    remarks?: string;
    subsidized?: prospects_CreateProspectRequest.subsidized;
    urgency?: prospects_CreateProspectRequest.urgency;
};
export namespace prospects_CreateProspectRequest {
    export enum first_contact_channel {
        WEB = 'web',
        PHONE = 'phone',
        EMAIL = 'email',
        WHATSAPP = 'whatsapp',
        IN_PERSON = 'in_person',
    }
    export enum subsidized {
        YES = 'yes',
        NO = 'no',
        UNKNOWN = 'unknown',
    }
    export enum urgency {
        LOW = 'low',
        MEDIUM = 'medium',
        HIGH = 'high',
    }
}

